// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Menu-cls1___1f6d60f0492b8bb7465{/*!*/}.Menu-cls2__bfc8b1727f042fe6f261{overflow:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Menu-cls1___1f6d60f0492b8bb7465",
	"cls2": "Menu-cls2__bfc8b1727f042fe6f261 Menu-cls1___1f6d60f0492b8bb7465"
};
export default ___CSS_LOADER_EXPORT___;
